'use client'

import React, { useState, useContext, createContext } from 'react'

const LogoutContext = createContext()

export const useLogoutData = () => {
  const context = useContext(LogoutContext)
  if (!context) {
    throw new Error('useLogoutData must be used within a LogoutProvider')
  }
  return context
}

export const LogoutProvider = ({ children }) => {
  const [ logoutData, setLogoutData ] = useState(null)

  return (
    <LogoutContext.Provider value={{ logoutData, setLogoutData }}>
      {children}
    </LogoutContext.Provider>
  )
}